// extracted by mini-css-extract-plugin
export var printerCard = "_bf-1";
export var printerCardConfigured = "_bf-2";
export var printerCardError = "_bf-3";
export var printerCardsContainer = "_bf-0";
export var printerIcon = "_bf-8";
export var printerIconConfigured = "_bf-5";
export var printerIconContainer = "_bf-4";
export var printerIconError = "_bf-6";
export var printerIconUnconfigured = "_bf-7";
export var workstationsTableCard = "_bf-9";